import { defineComponent as C, ref as s, computed as S, provide as T, onMounted as v, watch as A, nextTick as B, openBlock as g, createBlock as h, Teleport as D, createVNode as y, Transition as _, withCtx as l, withDirectives as E, unref as k, createElementVNode as m, mergeProps as L, createSlots as O, renderSlot as r, toDisplayString as P, normalizeClass as R, createCommentVNode as Z, vShow as j } from "vue";
import { dialogEmits as K, dialogProps as M } from "./dialog.js";
import { ApOverlay as U } from "../overlay/index.js";
import { useNamespace as q } from "../../hooks/use-namespace.js";
import { useZIndex as F } from "../../hooks/use-z-index.js";
import { addUnit as G } from "../../utils/style.js";
import H from "./dialog-content.vue.js";
import { dialogInjectionKey as J } from "./token.js";
import "./dialog.css";
const Q = {
  role: "dialog",
  "aria-modal": "true",
  class: "ap-overlay-dialog"
}, W = { role: "heading" }, X = C({
  name: "ApDialog"
}), ie = /* @__PURE__ */ C({
  ...X,
  props: M,
  emits: K,
  setup(b, { emit: V }) {
    const o = b, d = V, u = q("dialog"), $ = s(), w = s(), { nextZIndex: f } = F(), t = s(!1), a = s(!1), i = s(o.zIndex || f()), n = (e) => d("update:modelValue", e), z = S(() => {
      const e = {};
      return o.width && (e.width = G(o.width)), e;
    });
    T(J, {
      headerRef: $,
      dialogRef: w,
      rendered: t,
      ns: u,
      style: z
    });
    const c = () => {
      a.value = !0, n(!0);
    }, I = () => {
      d("closed"), n(!1), o.destroyOnClose && (t.value = !1);
    }, p = () => {
      a.value = !1, n(!1);
    }, N = () => {
      p();
    };
    return v(() => {
      o.modelValue && (a.value = !0, c());
    }), A(
      () => o.modelValue,
      (e) => {
        e ? (c(), t.value = !0, i.value = o.zIndex ? i.value++ : f(), B(() => {
          d("open");
        })) : a.value && p();
      }
    ), v(() => {
      o.modelValue && (t.value = !0);
    }), (e, Y) => (g(), h(D, {
      to: "body",
      disabled: !e.appendToBody
    }, [
      y(_, {
        name: "dialog-fade",
        onAfterLeave: I
      }, {
        default: l(() => [
          E(y(k(U), {
            mask: e.modal,
            "overlay-class": e.modalClass,
            "z-index": i.value
          }, {
            default: l(() => [
              m("div", Q, [
                t.value ? (g(), h(H, L({ key: 0 }, e.$attrs, {
                  "custom-class": e.customClass,
                  title: e.title,
                  draggable: e.draggable,
                  onClose: N
                }), O({
                  header: l(() => [
                    e.$slots.title ? r(e.$slots, "title", { key: 1 }) : r(e.$slots, "header", { key: 0 }, () => [
                      m("span", W, P(e.title), 1)
                    ])
                  ]),
                  default: l(() => [
                    r(e.$slots, "default")
                  ]),
                  _: 2
                }, [
                  e.$slots.footer ? {
                    name: "footer",
                    fn: l(() => [
                      m("footer", {
                        class: R(k(u).e("footer"))
                      }, [
                        r(e.$slots, "footer")
                      ], 2)
                    ]),
                    key: "0"
                  } : void 0
                ]), 1040, ["custom-class", "title", "draggable"])) : Z("", !0)
              ])
            ]),
            _: 3
          }, 8, ["mask", "overlay-class", "z-index"]), [
            [j, a.value]
          ])
        ]),
        _: 3
      })
    ], 8, ["disabled"]));
  }
});
export {
  ie as default
};
